import React from  'react';
import { useAuth } from '../../context/AuthContext';
import NavLogged from '../HomeLogged/NavLogged/NavLogged';
import Nav from './Nav/Nav';

export default function RightNav() {
    const { isLoggedIn } = useAuth();

    return(
        <>
            {isLoggedIn ? <NavLogged /> : <Nav />}
        </>
    )
   
}